import {
  Flex,
  Text,
  Badge,
  Spacer,
  Box,
  InputGroup,
  InputLeftElement,
  Input,
  Checkbox
} from '@chakra-ui/react'
import { ChangeEvent, FC, useEffect, useState } from 'react'
import { BsSearch } from 'react-icons/bs'

import useParametrizationCurveStore from '@hook/parametrization/use-curve-store'

import ParametrizationCurveStoreCreate from './ModalCreate'
import ParametrizationCurveStoreModalDelete from './ModalDelete'

const SelectedTableBarCurveStore: FC = () => {
  const {
    selecteds,
    data,
    handleSelectAll,
    getData,
    setQuery,
    query: lastQuery
  } = useParametrizationCurveStore()

  const [query, setQueryNew] = useState(lastQuery)
  const [queryLast, setQueryNewLast] = useState(lastQuery)

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    // getData(value, 0, 50, true)
    setQueryNew(value)
    setQuery(value)
  }
  useEffect(() => {
    if (query.trim() !== '' || queryLast !== '') {
      const delayDebounceFn = setTimeout(() => {
        setQueryNewLast(query)
        // Chama a API somente se o valor não estiver vazio
        getData(query, 0, 50, true)
      }, 2000) // Atraso de 2 segundos após a última alteração no inputValue

      return () => clearTimeout(delayDebounceFn)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query])

  return (
    <Flex
      borderBottom="solid 1px"
      borderColor="gray.200"
      alignItems="center"
      justifyContent="space-between"
      paddingY={2}
      paddingX={4}
      mr={10}
    >
      {data.length > 0 && (
        <>
          <Flex alignItems="center">
            <Checkbox
              color="black"
              iconColor="blue.400"
              borderColor="gray.400"
              isChecked={selecteds.length === data.length}
              onChange={handleSelectAll}
            >
              Selecionar Tudo
            </Checkbox>
          </Flex>
          <Flex alignItems="center">
            <Badge
              h="16px"
              minW="16.5px"
              marginRight={2}
              ml="1"
              color="#4b64c9"
              border="1px solid #4b64c9"
              background="#c0d9ff"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              {selecteds.length}
            </Badge>
            <Text color={'black'}>Itens Selecionados</Text>
          </Flex>
        </>
      )}

      <Spacer />
      <Box w="240px" pl={2} pr={4}>
        <InputGroup size="sm" borderColor="gray.200">
          <InputLeftElement pointerEvents="none">
            <BsSearch color="var(--chakra-colors-gray-400)" />
          </InputLeftElement>
          <Input
            placeholder="Buscar..."
            borderRadius="8px"
            pl={8}
            value={query}
            onChange={handleInputChange}
            isDisabled={false}
            _hover={{
              borderColor: 'yellow.400'
            }}
            _placeholder={{
              color: 'gray.400'
            }}
          />
        </InputGroup>
      </Box>

      {selecteds.length > 0 ? <ParametrizationCurveStoreModalDelete /> : []}
      {selecteds.length <= 1 ? <ParametrizationCurveStoreCreate /> : []}
    </Flex>
  )
}

export default SelectedTableBarCurveStore
